export const ToggleWebsocketActions = {
  RETRIEVE_FEATURES: "retrieveFeatures",
};
